import * as types from "../constants";

const initialState = {
  results: null
};

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.SET_INSTAGRAM_RESULTS:
      return {
        ...state,
        results: actions.payload
      };

    default:
      return state;
  }
}
